export const isSpectraQualityOrder = (database: string) => {
  return database === "Escherichia-coli-spectra-quality";
};
